import React from 'react';

import createStyle from 'shared-utils/src/createStyle';

// import BackIcon from 'shared-vectors/icons/Back';
import Phone from 'shared-vectors/icons/Phone';
import Mail from 'shared-vectors/icons/Mail';
import { Icon } from 'shared-vectors';

import Grid from '../../../../Grid';
import GridItem from '../../../../GridItem';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

export default function CtaSlide({
  img,
  // goToFirst,
  isMobile,
  actions,
}) {
  const cls = useStyles();

  const linkCLick = (e) => actions.goToPDP({ e });

  return (    
    <div className="is-rel c-bg--w" style={{ width: '100%', height: '100%' }}>
      <Grid
        className={`${cls[mainCls]} is-nosel`}
        direction="column"
        justify="center"
        align="center"
      >
        <GridItem behavior="fixed" className="mb--s tp-s--l tp-w--l c-txt--f1">
          Ti interessa?
        </GridItem>
        <GridItem behavior="fixed">
          <Grid
            justify="center"
            align="center"
          >
            <button
              type="button"
              className={`${cls[`${mainCls}__btn`]} phoneCall mr--m tp-w--l c-txt--w c-bg--secondary b--0 b-r--m is-clickable`}
              onClick={actions.phoneReveal}
            >
              <Icon name={Phone} className={cls[`${mainCls}__btn--phone`]} /> Chiama
            </button>
            <button
              type="button"
              className={`${cls[`${mainCls}__btn`]} specificLead tp-w--l c-txt--w c-bg--primary b--0 b-r--m is-clickable`}
              onClick={actions.sendMail}
            >
              <Icon name={Mail} className={cls[`${mainCls}__btn--mail`]} /> <span>{isMobile ? 'Contatta' : 'Invia messaggio'}</span>
            </button>
          </Grid>    
        </GridItem>
        <GridItem
          className={cls[`${mainCls}__sep`]}
          behavior="fixed"
        />
        <GridItem behavior="fixed"
          onClick={linkCLick}
          className={`${cls[`${mainCls}__pdpbtn`]} is-clickable c-bg--w tp-w--m tp-s--s b-r--pill`}
        >
          Vedi tutti i dettagli
        </GridItem>
        {/* <GridItem behavior="fixed"
          onClick={goToFirst}
          className={`${cls[`${mainCls}__back`]} c-txt--secondary is-clickable tp-w--m tp-s--s`}
        >
          <span className={cls[`${mainCls}__back--txt`]}>Torna all’inizio</span> <Icon name={BackIcon} />
        </GridItem> */}
      </Grid>
      <img
        className={cls[`${mainCls}__img`]}
        src={`https://images-1.casa.it/360x265${img.uri}`}
        alt={img.alt || ''}
      />
    </div>
  );
}